import { D as Dropdown, d as defineCustomElement$1 } from './dropdown.js';

const TtDropdown = Dropdown;
const defineCustomElement = defineCustomElement$1;

export { TtDropdown, defineCustomElement };
